export default __webpack_public_path__ + "static/media/node-r-bg.e22f5458.png";